window.onpageshow = function(event) {  
    if (event.persisted) {
  		location.reload(true);
    }     
};

$(document).ready(function(){
  
  
 
  var cur_time;
  cur_time = new Date().getTime();
  //change on 19 oct - hide personalized button when user select 24 party cup
   var selectedOption1 = jQuery("#SingleOptionSelector-0").children("option:selected").val()
   var selectedOption2 = jQuery("#SingleOptionSelector-1").children("option:selected").val()

   if(selectedOption1 == '24 party cups' && selectedOption2 == 'Bella' ){

      jQuery("#createown").css('display','none');
    }else{

      jQuery("#createown").css('display','block');
    }



    jQuery("#SingleOptionSelector-1").change(function(){

      var selectedOption1 = $(this).children("option:selected").val();

      var selectedOption2 = jQuery("#SingleOptionSelector-0").children("option:selected").val()

      if(selectedOption1 == 'Bella' && selectedOption2 == '24 party cups' ){

        jQuery("#createown").css('display','none');
      }else{

        jQuery("#createown").css('display','block');
      }

    });

    jQuery("#SingleOptionSelector-0").change(function(){

      var selectedOption1 = $(this).children("option:selected").val();

      var selectedOption2 = jQuery("#SingleOptionSelector-1").children("option:selected").val()

      if(selectedOption2 == 'Bella' && selectedOption1 == '24 party cups' ){

      jQuery("#createown").css('display','none');
    }else{

      jQuery("#createown").css('display','block');
    }

    });


 $('#createown').on('click' ,function(){


      var selected_variant_id = ShopifyAnalytics.meta.selectedVariantId;
      var base,flavor,mix_ins_arr = [],mix_ins_str = '',length,arr = {},final_title_str;
      var selected_products_text,mix_ins,selected_products,seleted_base_id;
	  var designer_url = $(this).attr('data-design-url');

      if(!$('input[name="properties[Base]"]').is(':checked')) {

         alert("Please Select Base Flavor");
         return false;
       }else{

         base = $('input[name="properties[Base]"]:checked').val();
       	 seleted_base_id = $('input[name="properties[Base]"]:checked').attr('data-id');
       }


       if(!$(".flavor input[data-id='"+seleted_base_id+"']").is(':checked')) {

         alert("Please Select Flavor");
         return false;
       }else{

       	 flavor = $(".flavor input[data-id='"+seleted_base_id+"']:checked").val();

       }

		  //to make mix-ins as required field
//        if($('input[name="properties[Mix-ins]"]').val() == '') {

//          alert("Please Select at least one Mix-ins");
//          return false;
//        }


      length = $('.container input[name="Mix-ins"]:checked').length;

      $('.container input[name="Mix-ins"]:checked').each(function(i){

          mix_ins_arr.push($(this).val());

          if(mix_ins_str==''){

            mix_ins_str = $(this).val();
          } else if(i==length-1){

            mix_ins_str = mix_ins_str+' & '+ $(this).val();
          } else{

            mix_ins_str = mix_ins_str+','+ $(this).val();
          }
      });

      final_title_str = '';

      if(flavor != ''){
          final_title_str += flavor;
      }

      if(base != ''){
          final_title_str+= ' '+base;
      }
//calculate_remain_pack();
      if(mix_ins_str != ''){
          final_title_str+= ' with '+ mix_ins_str;
      }

      arr['0'] = final_title_str;
      selected_products_text = JSON.stringify(arr);
      mix_ins = mix_ins_arr.join(',');
      selected_products = '';

     // designer_url = designer_url+selected_variant_id+ '/isAjax/1';
      $('#selected_base').val(window.btoa(base));
      $('#selected_flavor').val(window.btoa(flavor));
      $('#selected_mix_ins').val(window.btoa(mix_ins));
      $('#sid').val(window.btoa(selected_variant_id));
      $('#selected_products').val(window.btoa(selected_products_text));
      $('#current_timestamp').val(window.btoa(cur_time));
      $('#ecre-custom-flavor').attr('action',designer_url);

      $('#ecre-custom-flavor').submit();
  });


  //display mix-ins at cart page
  var tmp_mix_ins_arr = new Array();
  $('input[name="Mix-ins"]').change(function(){

    var $el = $(this);

    setTimeout(function() {
      completely_mix_ins($el);
    }, 100);

  });


  function completely_mix_ins($el){

    $el.each(function(){

    if ($el.is(":checked")) {

      var selected_mix_ins_com = $el.val();
      var tmp_mix_ins_str;
      tmp_mix_ins_str = tmp_mix_ins_str + selected_mix_ins_com+", ";

      tmp_mix_ins_arr.push(selected_mix_ins_com);

    }else{

      var deselected_mix_ins_com = $el.val();
      var index = tmp_mix_ins_arr.indexOf(deselected_mix_ins_com);
      if (index > -1) {
        tmp_mix_ins_arr.splice(index, 1);
      }
    }

    });

    if (tmp_mix_ins_arr.length > 0) {

      var tmp_mix_ins_str = tmp_mix_ins_arr.join(", ");

      $('input[name="properties[Mix-ins]"]').val(tmp_mix_ins_str);

   }else{

   	 $('input[name="properties[Mix-ins]"]').val('');

   }
  }
  
});